import { storeSettings } from './settings/store.settings'
import { storeTelegram } from './telegram/store.telegram'

export const reducers = {
  [storeSettings.name]: storeSettings.reducer,
  [storeTelegram.name]: storeTelegram.reducer,
}
